import { Injectable } from '@angular/core';
import { Toast, ToastController } from "ionic-angular";

@Injectable()
export class ToastService {
  private toast: Toast;

  constructor(private toastCtrl: ToastController) {
  }

  private initToast(message: string, duration?: number) {
    this.toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      showCloseButton: true,
      closeButtonText: 'OK',
      dismissOnPageChange: true
    });
  }

  public showError(errorCode: number) {
    let message: string;
    if (this.toast) {
      this.toast.dismissAll();
    }
    switch (errorCode) {
      case 400:
        message = 'Données envoyées invalides. Veuillez vérifier les données saisies et réessayer.';
        break;

      case 401:
        message = 'Accès refusé. Veuillez vérifier vos identifiants ou contacter votre administrateur.';
        break;

      case 404:
        message = 'Chemin introuvable.';
        break;

      default:
        message = 'Une erreur s\'est produite.';
    }
    this.initToast(message);
    this.toast.present();
  }

  public showSuccess(message: string, duration: number = 5000) {
    this.initToast(message, duration);
    this.toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/toast.service.ts